// Get All Labor Classes
export const GET_LABOR_CLASS_LISTING_REQUEST =
  'GET_LABOR_CLASS_LISTING_REQUEST';
export const GET_LABOR_CLASS_LISTING_SUCCESS =
  'GET_LABOR_CLASS_LISTING_SUCCESS';
export const GET_LABOR_CLASS_LISTING_FAIL = 'GET_LABOR_CLASS_LISTING_FAIL';

// Create Labor Classes
export const CREATE_LABOR_CLASS_REQUEST = 'CREATE_LABOR_CLASS_REQUEST';
export const CREATE_LABOR_CLASS_SUCCESS = 'CREATE_LABOR_CLASS_SUCCESS';
export const CREATE_LABOR_CLASS_FAIL = 'CREATE_LABOR_CLASS_FAIL';

// updating list of labor class after creating new
export const UPDATE_LABOR_CLASS_LIST = 'UPDATE_LABOR_CLASS_LIST';
// Update Labor Classes
export const UPDATE_LABOR_CLASS_REQUEST = 'UPDATE_LABOR_CLASS_REQUEST';
export const UPDATE_LABOR_CLASS_SUCCESS = 'UPDATE_LABOR_CLASS_SUCCESS';
export const UPDATE_LABOR_CLASS_FAIL = 'UPDATE_LABOR_CLASS_FAIL';

// DEelete Labor Classes
export const DELETE_LABOR_CLASS_REQUEST = 'DELETE_LABOR_CLASS_REQUEST';
export const DELETE_LABOR_CLASS_SUCCESS = 'DELETE_LABOR_CLASS_SUCCESS';
export const DELETE_LABOR_CLASS_FAIL = 'DELETE_LABOR_CLASS_FAIL';

// clear lobor state data
export const CLEAR_LABOR_STATE = 'CLEAR_LABOR_STATE';
